export default {
  pageTitle: {
    id: 'bo_seller.kyb.account_requester.page_title',
    defaultMessage: 'KYB - Account requester details',
  },
  title: {
    id: 'bo_seller.kyb.account_requester.title',
    defaultMessage: 'Account requester details',
  },
  description: {
    id: 'bo_seller.kyb.account_requester.description',
    defaultMessage:
      'Fill out details for the account requester, that is, the person responsible for opening the account.',
  },
  saveButton: {
    id: 'bo_seller.kyb.account_requester.save_button',
    defaultMessage: 'Save',
  },
  saveSuccessTitle: {
    id: 'bo_seller.kyb.account_requester.save_success_title',
    defaultMessage: 'Account requester details saved ✔️',
  },
  saveSuccessContent: {
    id: 'bo_seller.kyb.account_requester.save_success_content',
    defaultMessage: 'Nice work.',
  },
  saveErrorTitle: {
    id: 'bo_seller.kyb.account_requester.save_error_title',
    defaultMessage: "Account requester details weren't saved.",
  },
  savingAccountRequesterDetails: {
    id: 'bo_seller.kyb.account_requester.saving_account_requester_details',
    defaultMessage: 'Saving account requester details...',
  },
  loadingAccountRequesterDetails: {
    id: 'bo_seller.kyb.account_requester.loading_account_requester_details',
    defaultMessage: 'Loading account requester details...',
  },
} as const
